module.exports = __webpack_public_path__ + "img/star.4748c559.svg";